import React, { useState, useEffect } from 'react'
import CarouselView from '../../../../components/record-carousel'
import { hall } from "../../../../service";
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
    Button,
    Empty,
    Divider,
    Space,
    Collapse,
    Modal,
    Tag,
    message,
    Avatar,
    List,
    Tabs,
} from 'antd';
import {
    ArrowLeftOutlined,
    PhoneOutlined,
    FileTextOutlined,
    CaretDownOutlined,
    CaretRightOutlined,
} from '@ant-design/icons';
import SiteNewsView from "../../../../components/site-news";
import MapView from '../../../../components/map'
import './index.scss'

const shopcart = require("../../../../assets/image/Shop-Cart.png")
    , phone = require("../../../../assets/image/phone-fill.png")
    , company = require("../../../../assets/image/company.png")
    , lands = require("../../../../assets/image/lands.png")


export default function DetailsView() {
    const { id } = useParams()
        , navigate = useNavigate()
        , [record, setRecord] = useState({})
        , [order, setOrder] = useState([])
        , [total, setTotal] = useState(0)
        , [openModal, setOpenModal] = useState(false)
        , [openTemp, setOpenTemp] = useState(false)
        , [temp, setTemp] = useState(null)
        , basic = useSelector(state => state.basic)
        , { serverUrl } = useSelector(state => state.siteInfo)
        , mapRef = React.useRef(null)
        , [location, setLocation] = useState([])

    useEffect(() => {
        if (id) {
            async function fetchData() {
                // const { data } = await hall.apiRecord.getDetails(id)
                const { data } = await hall.apiHall.getDetails(id)
                const { data: { list, total } } = await hall.apiHall.getOrder(data.userId, 1)
                setRecord(data)
                setOrder(list)
                setTotal(total)
            }
            fetchData()
        }
    }, [])

    useEffect(() => {
        if (mapRef.current && record.positions?.length) {
            async function fetchData() {
                if (basic.position && basic.position.length) {
                    drawMarker([{ id: record.id, content: record.name, latlng: record.positions }, { id: basic.id, content: basic.name, latlng: basic.position }])
                } else {
                    drawMarker([{ id: record.id, content: record.name, latlng: record.positions }])
                }
            }
            fetchData()
        }
    }, [mapRef, record, basic])

    const drawMarker = (data, isClear = true) => {
        mapRef.current.drawStrips({
            data: data,
            mode: 'multiple',
            type: "Marker",
            pmIgnore: true,
            isFitBounds: true,
            isClear,
        })
    }

    const templeteView = async () => {
        const { data } = await hall.apiHall.tempView()
        setTemp(data)
        setOpenTemp(true)
    }

    const onOrder = () => {
        if (basic.id) {
            // to do  
        } else {
            setOpenModal(true)
        }
    }
    const onChat = () => {
        if (basic.id) {
            // to do  
        } else {
            setOpenModal(true)
        }
    }

    return (
        <div className='record-details-container'>
            <div className='details-header'>
                <Button
                    icon={<ArrowLeftOutlined />}
                    type='text'
                    onClick={() => navigate(-1)}
                >返回</Button>
            </div>
            {
                record.id ? (
                    // <div className='container-display-center'>
                    //     <div className='flex'>
                    //         <CarouselView images={record.image} />
                    //         <div className='record-info'>

                    //             <div className='info-item record-title'>
                    //                 {record.title}
                    //             </div>

                    //             <div className='info-item price-item'>
                    //                 <label>服务价格</label>
                    //                 <span className='price'>{record.price ? `${record.price} 元/${record.unit}` : '-'}</span>
                    //             </div>

                    //             <div className='info-item'>
                    //                 <label>服务品种</label>
                    //                 {record.classify1Name}
                    //             </div>

                    //             <div className='info-item'>
                    //                 <label>服务类型</label>
                    //                 {record.classify2Name}
                    //             </div>

                    //             <div className='info-item'>
                    //                 <label>服务区域</label>
                    //                 {record.province + record.city + record.town + (record.address || '')}
                    //             </div>

                    //             <div className='info-item'>
                    //                 <label>服务时间</label>
                    //                 {record.startDate + " ~ " + record.endDate}
                    //             </div>

                    //             <Divider />

                    //             <Space size={'large'}>
                    //                 <Button
                    //                     type='primary'
                    //                     icon={<img src={shopcart} />}
                    //                     className='shop-cart-btn'
                    //                     onClick={() => onOrder()}
                    //                 >立即下单</Button>

                    //                 {/* <Button
                    //                     type='default'
                    //                     icon={<img src={phone} />}
                    //                     className='shop-cart-btn shop-cart-phone'
                    //                     onClick={() => onChat()}
                    //                 >立即联系</Button> */}
                    //             </Space>

                    //         </div>
                    //     </div>

                    //     <Divider />

                    //     <div className='flex'>
                    //         <SiteNewsView
                    //             createUid={record.createUid}
                    //         />
                    //         <Card
                    //             title='需求详情'
                    //             className='m-l-lg'
                    //             style={{ width: 'calc(100% - 200px)' }}
                    //         >
                    //             {record.content}
                    //         </Card>
                    //     </div>
                    // </div>


                    <div className='container-display-center'>
                        <div className='flex'>
                            <CarouselView images={[record.imageUrl]} />

                            <div className='record-info'>
                                <div className='info-item record-title'>
                                    {record.name}
                                </div>

                                <div className='info-item price-item'>
                                    总签单<span className='color-primary m-sm'> {total} </span>单
                                </div>

                                <div className='info-item'>
                                    法人代表：{record.frdb}
                                </div>

                                <div className='info-item'>
                                    所在地址：{record.address}
                                </div>

                                <div className='info-item'>
                                    联系电话： <span><PhoneOutlined /> {
                                        basic.id ? (<>{record.phone}</>) : (<>{record.phone.slice(0, 3) + '****' + record.phone.slice(7, 11)}</>)
                                    }</span>
                                    <Button
                                        type='link'
                                        icon={<FileTextOutlined />}
                                        onClick={templeteView}>
                                        合同预览
                                    </Button>
                                </div>

                                <div className='info-item flex' style={{ margin: '0 auto' }}>
                                    <div style={{ lineHeight: '60px' }}>需求内容： </div>
                                    <Collapse
                                        style={{ width: '500px' }}
                                        expandIcon={(panelProps) => {
                                            // 根据折叠面板的展开状态，选择不同的图标
                                            const icon = panelProps.isActive ?
                                                <Tag className='info-tag' style={{ marginTop: 8 }} icon={<CaretDownOutlined />} bordered={false} color="gold">折叠</Tag>
                                                : <Tag className='info-tag' style={{ marginTop: 8 }} icon={<CaretRightOutlined />} bordered={false} color="gold">展开</Tag>;

                                            return (
                                                <span onClick={panelProps.onClick} style={{ marginRight: 8 }}>
                                                    {icon}
                                                </span>
                                            )
                                        }}
                                        expandIconPosition={'end'}
                                        defaultActiveKey={['1']} ghost items={[{
                                            key: '1',
                                            label: record.classifyNames.slice(0, 5).map(item =>
                                                <Tag key={item} bordered={false} color="lime" className='info-tag'>
                                                    {item}
                                                </Tag>
                                            ),
                                            children: record.classifyNames.slice(5,).length ? (
                                                record.classifyNames.slice(5,).map(item =>
                                                    <Tag key={item} bordered={false} color="lime" className='info-tag'>
                                                        {item}
                                                    </Tag>
                                                )) : (null)

                                        }]} />
                                </div>

                                <div className='info-item flex'>
                                    需求区域：<List
                                        style={{ width: '300px', marginLeft: '20px' }}
                                        dataSource={record.landList.slice(0, 3)}
                                        renderItem={(item, index) => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    avatar={<Avatar src={lands} />}
                                                    title={<span style={{ display: 'inline-block', marginTop: '5px' }}>{item.address}</span>}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>

                        <Divider />

                        <div className='flex'>
                            <Tabs
                                style={{ width: '600px' }}
                                defaultActiveKey="1"
                                items={[
                                    {
                                        key: '1',
                                        label: '需求记录',
                                        children: <List
                                            style={{ width: '480px', marginLeft: '20px' }}
                                            dataSource={order}
                                            renderItem={(item, index) => (
                                                <List.Item >
                                                    <List.Item.Meta
                                                        title={<span>{item.orderUserCompany}</span>}
                                                        description={`${item.classifyName} - ${item.createDate}`}
                                                    />
                                                </List.Item>
                                            )}
                                        />
                                    },
                                ]} />
                            <div style={{ flex: 1 }}>
                                <MapView
                                    ref={mapRef}
                                    id='devs-map'
                                    height='500px'
                                    isLocate={true}
                                >
                                </MapView>
                            </div>
                        </div>
                    </div>

                ) : (<Empty style={{ marginTop: '20vh', height: '50vh' }} />)
            }

            <Modal
                title='提示'
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={[
                    <Button key="back" onClick={() => setOpenModal(false)}>
                        取消
                    </Button>
                ]}
            >
                <div className='m-lg' style={{ fontSize: '18px' }}>
                    该功能需要登录后才可使用，现在<span
                        style={{ color: '#44AFAD', cursor: 'pointer', margin: '0 4px' }}
                        onClick={() => navigate('/login')}
                    >去登录！</span>
                </div>
            </Modal>

            <Modal
                title='合同模板'
                width={1200}
                open={openTemp}
                onCancel={() => setOpenTemp(false)}
                footer={[
                    <Button key="back" onClick={() => setOpenTemp(false)}>
                        取消
                    </Button>
                ]}
            >
                <div dangerouslySetInnerHTML={{ __html: temp }} />
            </Modal>


        </div>
    )
}
